const headers = { "Content-Type": "application/json" }
const apiUrl = process.env.NODE_ENV === "development" ? "/api" : ""

export const GET = (url: string) => (
    fetch(apiUrl + url, {})
    .then((res) => res.json())
)

export const POST = (url: string, data: string) => (
    fetch(apiUrl + url, {
        method: "POST",
        body: data,
        headers,
    }).then((res) => res.json())
)

export const DELETE = (url: string) => (
    fetch(apiUrl + url, {
        method: "DELETE",
        headers,
    }).then((res) => res.json())
)

export const QUERY = (sql: string) => (
    fetch(`${apiUrl}/query`, {
        method: "POST",
        body: JSON.stringify({ sql }),
        headers,
    }).then((res) => res.json())
)
